import { useMemo, useState } from 'react';
import type { Product } from '../types/@types/product';

export function useOrderItemOptions(product?: Product) {
  const [additions, setAdditions] = useState<Record<string, number>>({});
  const [exceptions, setExceptions] = useState<string[]>([]);

  const cfg = useMemo(
    () => ({
      additions: product?.additions?.enabled ? product?.additions?.options ?? [] : [],
      exceptions: product?.exceptions?.enabled ? product?.exceptions?.options ?? [] : [],
    }),
    [product],
  );

  const incAddition = (key: string, maxQty = 1) =>
    setAdditions((prev) => {
      const current = prev[key] ?? 0;
      if (current >= maxQty) return prev;
      return { ...prev, [key]: current + 1 };
    });

  const decAddition = (key: string) =>
    setAdditions((prev) => {
      const current = prev[key] ?? 0;
      const next = Math.max(0, current - 1);
      const copy = { ...prev, [key]: next };
      if (next === 0) delete copy[key];
      return copy;
    });

  const toggleException = (key: string) =>
    setExceptions((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );

  return {
    additions,
    exceptions,
    setAdditions,
    setExceptions,
    incAddition,
    decAddition,
    toggleException,
    cfg,
  };
}
